import {keepPreviousData, useQuery} from '@tanstack/react-query';

import {apiClient} from '../../../../utils/api-client';

export function useListFavoritesQuery(globalVersionId: number) {
    return useQuery({
        queryKey: ['favoritesViewMode', globalVersionId],
        queryFn: () =>
            apiClient.callApi<ViewModeDoc[]>({
                path: 'documents-revisions-service/api/user/documents/favorite',
                method: 'GET',
                query: {
                    'global-version': globalVersionId
                }
            }),
        placeholderData: keepPreviousData
    });
}
